import { InvalidIcon } from "@ui/components/Icon";
import { tv } from "@ui/lib/tv";
import type { ReactNode } from "react";

const wizardFieldError = tv({
  slots: {
    root: [
      "mt-3 flex items-center justify-center gap-1.5 text-pink-600",
      "motion-safe:animate-in motion-safe:fade-in motion-safe:slide-in-from-top-1 motion-safe:duration-200",
    ],
    icon: "shrink-0 text-pink-500 [&_svg]:size-6",
    message: "text-base/6 font-medium",
  },
});

export interface WizardFieldErrorProps {
  children: ReactNode;
  className?: string;
  /** id for the message `<p>` — for consumers wiring the input's aria-describedby (NumberStepper). */
  id?: string;
}

/** Centred, icon-led validation message for the wizard's single-question selection stages
 *  (radio / checkbox / number stepper). Speaks the same pink + InvalidIcon language as the
 *  WizardTextField pill, but is centred to sit inside the stage's centred composition — a
 *  left-aligned field error reads as orphaned under a centred set of option cards.
 *  `role="alert"` announces it to assistive tech when it appears. */
export function WizardFieldError({ children, className, id }: WizardFieldErrorProps) {
  const styles = wizardFieldError();

  return (
    <p className={styles.root({ className })} id={id} role="alert">
      <span aria-hidden="true" className={styles.icon()}>
        <InvalidIcon />
      </span>
      <span className={styles.message()}>{children}</span>
    </p>
  );
}
